import { Injectable, inject } from '@angular/core';
import { ApiUrl, IrisApiClient, IrisQueryParams } from '@iris/api-query';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IrisDMSFileI } from '@iris/common/modules/dms/models/IrisDMSFile';
import { IrisDMSFolderI } from '@iris/common/modules/dms/models/IrisDMSFolder';
import { IrisDMSFolderOrFile } from '@iris/modules/dms/utils/file.utils';

export interface TrashBinResponse {
  files: IrisDMSFileI[];
  folders: IrisDMSFolderI[];
  count: number;
}

@Injectable({ providedIn: 'root' })
@ApiUrl('/dms2/{iris@instanceId}')
export class IrisTrashBinService extends IrisApiClient<TrashBinResponse> {
  protected readonly http: HttpClient;

  constructor() {
    const http = inject(HttpClient);

    super(http);
  
    this.http = http;
  }

  @ApiUrl('~/trash/project/{projectId}')
  public getEntities(projectId: number, params: IrisQueryParams = new IrisQueryParams()): Observable<TrashBinResponse> {
    return this.httpClient.get<TrashBinResponse>(this.url({ projectId }), { params: params.toObject() });
  }

  @ApiUrl('~/trash/{id}/restore')
  public restore(id: string): Observable<IrisDMSFolderOrFile> {
    return this.httpClient.post<IrisDMSFolderOrFile>(this.url({ id }), {});
  }

  @ApiUrl('~/bulk/remove/trash/{projectId}')
  public removeBulk(projectId: number, includeIds: string[], excludeIds: string[], params: IrisQueryParams = new IrisQueryParams()): Observable<IrisDMSFolderOrFile[]> {
    return this.httpClient.post<IrisDMSFolderOrFile[]>(
      this.url({ projectId }),
      this.convertIdsToParams(includeIds, excludeIds),
      params.toObject(),
    );
  }

  @ApiUrl('~/bulk/trash/{projectId}/restore')
  public restoreBulk(projectId: number, includeIds: string[], excludeIds: string[], params: IrisQueryParams = new IrisQueryParams()): Observable<IrisDMSFolderOrFile[]> {
    return this.httpClient.post<IrisDMSFolderOrFile[]>(
      this.url({ projectId }),
      this.convertIdsToParams(includeIds, excludeIds),
      params.toObject(),
    );
  }

  private convertIdsToParams(includeIds: string[], excludeIds: string[]): Record<string, string[]> {
    let params;
    if (includeIds) {
      params = {
        includeIds,
      };
    }

    if (excludeIds) {
      params = {
        ...params,
        excludeIds,
      };
    }

    return params;
  }
}
